// @ts-nocheck

// Drift control for zoom dialog
let driftInstances = [];

function disableDrift() {
  driftInstances.forEach(instance => {
    instance.disable();
  });
}

function enableDrift() {
  driftInstances.forEach(instance => {
    instance.enable();
  });
}

function isProductPage() {
  // Shopify product page typically has template name or unique element
  return window.location.pathname.includes('/products/') || document.body.classList.contains('template-product');
}

function initDriftZoom() {
  if (!isProductPage()) return;
  const images = document.querySelectorAll('.product-media__image');
  images.forEach(img => {
    if (img.dataset.driftInitialized) return;
    img.dataset.driftInitialized = 'true';
    // Create Drift instance
    const drift = new Drift(img, {
      paneContainer: img.closest('.product-media'),
      inlinePane: false,
      hoverBoundingBox: true,
      zoomFactor: 1.5,
      containInline: true,
      sourceAttribute: 'data_max_resolution',
    });
    driftInstances.push(drift);
  });
}

document.addEventListener('DOMContentLoaded', initDriftZoom);
document.addEventListener('shopify:section:load', initDriftZoom);

// Listen for zoom dialog open/close
window.addEventListener('dialog-open', disableDrift);
window.addEventListener('dialog-close', enableDrift);
